import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Home from './pages/Home';
import MovieDetailsPage from './components/MovieDetails';
import Navbar from './components/Navbar';

function App() {
  const categories = [
    { name: 'Popular Movies', endpoint: '/movie/popular' },
    { name: 'Top Rated Movies', endpoint: '/movie/top_rated' },
    { name: 'Upcoming Movies', endpoint: '/movie/upcoming' },
  ];

  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  return (
    <BrowserRouter>
      <div>
        <Navbar 
          categories={categories} 
          setSelectedCategory={setSelectedCategory} 
        />
        <Routes>
          <Route 
            path="/" 
            element={
              <Home 
                selectedCategory={selectedCategory} 
                setSelectedCategory={setSelectedCategory} 
              />
            } 
          />
          <Route path="/movie/:id" element={<MovieDetailsPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
